<template>
  <v-card class="d-flex flex-column align-center justify-center mx-md-4 my-md-4 elevation-0 py-16" outlined>
    <img :src="markView ? MarkImage : InputMarkImage" alt="student-setting" />
    <span class="mt-4">
      {{ action }}
    </span>
  </v-card>
</template>

<script>
import MarkImage from '@/assets/mark-view-icon.svg'
import InputMarkImage from '@/assets/mark-input-icon.svg'

export default {
  components: {},
  props: {
    markView: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      MarkImage,
      InputMarkImage
    }
  },
  computed: {
    action() {
      return this.markView
        ? `Vui lòng cung cấp các thông tin ở trên,
 sau đó ấn [Xem điểm] để xem bảng điểm `
        : `Vui lòng cung cấp các thông tin ở trên,
 sau đó ấn [Chọn nhập] để bắt đầu thao tác nhập điểm`
    }
  }
}
</script>

<style></style>
